import React, {Component} from 'react';
import {NavLink, withRouter} from 'react-router-dom';
import {inject, observer} from 'mobx-react';
import HttpClient from 'services/HttpClient';
import classNames from 'classnames';
import {TOPIC_TYPE_NAME} from 'constants/topicTypes';
import {Logo} from '../components/Logo';
import logo from '../../../images/Logo.png';
import sign from '../../../images/rayan.png';

const TOPICS_REQUEST = '/api/v1/tutorials/';

@withRouter
@inject('sideBarStore')
@inject('userStore')
@inject('headerStore')
@inject('examPrepHeaderStore')
@observer
class ExamPrepHeader extends Component {
  componentWillMount() {
    const {examPrepHeaderStore} = this.props;

    examPrepHeaderStore.clear();
    window.addEventListener('scroll', this.handleScroll);
  }

  handleSidebar = () => {
    this.props.sideBarStore.activate();
  };

  handleIsLanding = (location) => {
    return location.pathname === '/' || location.pathname === '/pricing';
  };

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  handleScroll = () => {
    if(this.props.location.pathname === '/' || this.props.location.pathname === '/pricing') {
      const el = document.getElementsByClassName('landing');
      const elPos = el[0].getBoundingClientRect();
      const wasScrolled = this.props.headerStore.isScrolled;

      if((elPos.top < -5) && !wasScrolled) {
        this.props.headerStore.scrolled();
      }

      if((elPos.top > -5) && wasScrolled) {
        this.props.headerStore.scrolled();
      }
    }
  };

  getTitle = (type, title) => {
    switch (type) {
      case 'cct':
        return title.replace('MICGP ', '');
      default:
        return title;
    }
  };

  getResourcesTitle = (type) => {
    switch (type) {
      case 'cct':
        return 'CCT Practice Cases';
      case 'ckt':
        return 'CKT Revision Summaries';
      default:
        return '';
    }
  };

  renderButtons = (topic) => {
    const {tutorial_type, title} = topic || {};
    const showResources = tutorial_type === 'cct' || tutorial_type === 'ckt';

    return (
      <div className='navbar-exam-prep'>
        {showResources && (
          <NavLink to={`/exam-prep/${topic.id}/practice-cases?resourse_type=${tutorial_type}`}>
            <div className="btn blue rounded navbar-exam-prep-buttons">
              <span>{this.getResourcesTitle(tutorial_type)}</span>
            </div>
          </NavLink>
        )}
        <NavLink to={`/exam-prep/topic/${topic.id}`}>
          <div className="btn blue rounded navbar-exam-prep-buttons">
            <span>{this.getTitle(tutorial_type, title)}</span>
          </div>
        </NavLink>
        <NavLink to={`/exam-prep/${topic.id}/topics`}>
          <div className="btn blue rounded navbar-exam-prep-buttons">
            <span>CLINICAL TOPICS</span>
          </div>
        </NavLink>
        <NavLink to={`/exam-prep/${topic.id}/reimbursed`}>
          <div className="btn blue rounded navbar-exam-prep-buttons">
            <span>{`${TOPIC_TYPE_NAME[tutorial_type]} REIMBURSEMENT`}</span>
          </div>
        </NavLink>
      </div>
    );
  };

  handleShowButtons = (topic, showButtons) => {
    if (showButtons) {
      return this.renderButtons(topic);
    }

    return null;
  };

  render() {
    const {location, userStore, examPrepHeaderStore} = this.props;
    const {topic, showButtons} = examPrepHeaderStore;
    const activeSearch = this.props.headerStore.isActiveSearch;
    const wasScrolled = this.props.headerStore.isScrolled;

    return (
      <header className={classNames('main-header fixed-top', {
        'landing-header': this.handleIsLanding(location) && !userStore.user,
        'is-scrolling': wasScrolled
      })}>
        <div className="container-fluid">
          <div className="row align-items-center justify-content-between no-wrap">
            <div className="col-5 col-sm-4 col-md-2">
              <NavLink
                className={classNames('logo', {'searchActive': activeSearch})}
                to={userStore.user ? '/' : '/'}>
                {Logo}
                <img src={logo} style={{ visibility: 'hidden', width: 0, height: 0 }} />
                <img src={sign} style={{ visibility: 'hidden', width: 0, height: 0 }} />
              </NavLink>
            </div>
            {this.handleShowButtons(topic, showButtons)}
            <div className="col-7 col-md-2">
              <div className="header-left-holder">
                <i onClick={this.handleSidebar}
                   className="ic ic-burger menu"/>
              </div>
            </div>
          </div>
        </div>
      </header>
    )
  }
}

export default ExamPrepHeader;



// WEBPACK FOOTER //
// ./src/modules/core/containers/ExamPrepHeader.js